import {
  AfterContentInit,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import {
  InfoPageDialogComponent,
  InfoPageTemplate,
} from 'src/app/components/dialogs';
import { BookingService } from 'src/app/services';

@Component({
  selector: 'app-step3-requirements-info-page-sdv',
  templateUrl:
    './step3-requirements-info-page-sdv.component.html',
  styleUrls: [
    './step3-requirements-info-page-sdv.component.scss',
  ],
})
export class Step3RequirementsInfoPageSdvComponent
  implements AfterContentInit
{
  @Output() stepLoaded: EventEmitter<void> =
    new EventEmitter<void>();

  modalRef?: BsModalRef;

  constructor(
    private bookingService: BookingService,
    private modalService: BsModalService,
    private router: Router
  ) {}

  ngAfterContentInit() {
    this.stepLoaded.emit();
  }

  showInfoModal(event: MouseEvent, template: string): void {
    event.preventDefault();
    this.modalRef = this.modalService.show(
      InfoPageDialogComponent,
      {
        class: 'modal-lg',
        initialState: {
          template: template as InfoPageTemplate,
        },
      }
    );
  }

  async cancelBooking(): Promise<void> {
    if (this.bookingId > 0) {
      await this.bookingService
        .deleteBooking(this.bookingId)
        .finally(() => {
          this.bookingService.formState = {
            loading: false,
            item: BookingService.factoryItem(),
          };
        });
    }
    this.router.navigate(['/home']);
  }

  private get bookingId(): number {
    return this.bookingService.formState.item.bookingId;
  }

  async submit(): Promise<boolean> {
    return true;
  }
}
